// src/components/layout/AppShell.jsx
import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSync } from '../../store/SyncContext';
import TopNav from './TopNav';
import OfflineBanner from './OfflineBanner';
import InternalBotV2 from '../bot/InternalBotV2';

export default function AppShell() {
  const { isOnline, pendingCount } = useSync();

  return (
    <div style={{
      display: 'flex', flexDirection: 'column',
      height: '100vh', overflow: 'hidden',
      background: 'var(--bg1)',
    }}>
      {/* Primary navigation bar */}
      <TopNav />

      {/* Offline indicator banner */}
      {!isOnline && <OfflineBanner pendingCount={pendingCount} />}

      {/* Page content area */}
      <main style={{ flex: 1, overflowY: 'auto', minHeight: 0 }}>
        <Outlet />
      </main>

      {/* Internal information chatbot */}
      <InternalBotV2 />
    </div>
  );
}